import { serializeAsOfDateSetting, analyticsService } from 'venn-utils';
import type { HistoricalPortfolioContextValue } from '../AllocationPanelContext';
import { Match } from 'effect';
import { AllocationAsOfDateDropdown } from './AllocationAsOfDateDropdown';
import React from 'react';
import { AllocationAsOfDateDropdownPlaceholder } from './AllocationAsOfDateDropdownPlaceholder';
import { UNSAFE_formatStringDateForCalendarDropdown } from '../../calendar-dropdown/calendarDropdownUtils';

type AllocationAsOfDateSelectorProps = {
  allocationPanelContextValue: HistoricalPortfolioContextValue;
};

export const AllocationAsOfDateSelector = ({ allocationPanelContextValue }: AllocationAsOfDateSelectorProps) => {
  const [lastSelectedDate, setLastSelectedDate] = React.useState<string | undefined>(undefined);
  return Match.value(allocationPanelContextValue).pipe(
    Match.when(
      { status: 'success' },
      ({
        allocationDates,
        allocationsAsOfDate,
        lastUploadedAllocationsDate,
        setAllocationsAsOfDate,
        frequency,
        currentAsOfDate,
      }) => (
        <AllocationAsOfDateDropdown
          triggerSize="small"
          allocationsAsOfDate={allocationsAsOfDate}
          lastUploadedAllocationsDate={lastUploadedAllocationsDate}
          allocationDates={allocationDates}
          setAllocationsAsOfDate={(date) => {
            analyticsService.dropdownItemSSelected({
              label: 'ALLOCATOR_PANEL_AS_OF_DATE',
              type: 'primary dropdown',
              selectType: 'single-select',
              selection: serializeAsOfDateSetting(date),
            });
            setLastSelectedDate(serializeAsOfDateSetting(date));
            setAllocationsAsOfDate(date);
          }}
          frequency={frequency}
          currentDate={currentAsOfDate}
        />
      ),
    ),
    Match.when({ status: 'loading' }, () => (
      <AllocationAsOfDateDropdownPlaceholder
        triggerSize="small"
        lastSelectedDate={lastSelectedDate}
        lastFormattedDisplayDate={
          lastSelectedDate ? UNSAFE_formatStringDateForCalendarDropdown(lastSelectedDate) : undefined
        }
      />
    )),
    Match.when({ status: 'error' }, () => (
      // todo: handle error state
      <AllocationAsOfDateDropdownPlaceholder
        triggerSize="small"
        lastSelectedDate={undefined}
        lastFormattedDisplayDate={undefined}
      />
    )),
    Match.exhaustive,
  );
};
